import { Card, Col, Row } from 'antd'
import { TimesheetsApi } from '../../../api/People/Timesheets'
import useFetchList from '../../../elements/Hooks/useFetchList'
import _, { get } from 'lodash'
import React, { Fragment } from 'react'
import RefreshButton from '../../../elements/Buttons/RefreshButton'
import CustomSpin from '../../../elements/CustomSpin'

const TableSummary = ({ data, fetching, fetch, title, keyID }) => {
  return (
    <CustomSpin spinning={fetching}>
      <Card
        title={
          <>
            {_.startCase(title)}
            <RefreshButton onClick={fetch}/>
          </>
        }
        style={{ margin: 'auto', marginBottom: 15 }}>
        {Object.keys(data).map(function(indexKey) {
          const value = keyID ? _.get(data[indexKey], keyID) : data[indexKey]
          return (
            <Row gutter={16} style={{ marginBottom: 5 }}>
              <Col span={10} style={{ fontWeight: 'bold' }}>
                {_.startCase(indexKey)}
              </Col>
              <Col span={14}>{value}</Col>
            </Row>
          )
        })}
      </Card>
    </CustomSpin>
  )
}

function TimesheetSummary (props) {
  const { timesheet } = props
  const { list, fetching, fetch } = useFetchList(
    () => TimesheetsApi.getSummary(_.get(timesheet, '_key')),
    [_.get(timesheet, '_key')],
  )
  const amount = get(list, 'amount', { Amount: 'No Data !' })
  let hour = get(list, 'period', { Period: 'No Data !' })
  return (
    <Fragment>
      <TableSummary
        fetch={fetch}
        fetching={fetching}
        title={'Amount'}
        data={amount}
      />
      <TableSummary
        fetching={fetching}
        fetch={fetch}
        title={'Period'}
        data={hour}
        keyID={'unit'}
      />
    </Fragment>
  )
}

export default TimesheetSummary
